import { BLOG_TOPIC_PATH_PREFIX } from '@/cms/api/constants';
import Badge from '@/components/atoms/badge';
import LinkButton from '@/components/atoms/LinkButton';

export interface PostTopic {
  topic: string;
  slug: string;
}

interface PostTagsProps {
  isNew: boolean;
  topics: PostTopic[];
}

export const PostTags = ({ isNew, topics }: PostTagsProps) => {
  return (
    <div
      className='flex flex-wrap items-center gap-2'
      data-tracker-component='post-tag'
    >
      {isNew && (
        <Badge
          variant='outlined'
          color='gradient'
          size='l'
          classNames={{ root: 'font-serif' }}
        >
          NEW
        </Badge>
      )}
      {!!topics &&
        topics.map((topic) => <PostTag key={topic.topic} {...topic} />)}
    </div>
  );
};

export const PostTag = ({ slug, topic }: PostTopic) => {
  return (
    <LinkButton
      href={`/${BLOG_TOPIC_PATH_PREFIX}/${slug}`}
      variant='text'
      color='primary'
      underline={false}
      classNames={{
        root: 'p-0 h-[21px] font-serif',
      }}
    >
      <Badge
        variant='soft'
        size='l'
        color='gray'
        classNames={{ root: 'cursor-pointer' }}
      >
        {topic.toUpperCase()}
      </Badge>
    </LinkButton>
  );
};
